import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import Settings from 'src/pages/Settings/Settings';
import Analytics from 'src/pages/Analytics/Analytics';
import ErrorPage from 'src/pages/ErrorPage';
import { GLOBAL_PATH_PREFIX } from 'src/constants';
import CreatorReports from 'src/pages/CreatorReports/CreatorReports';
import PresentationPage from 'src/presentation/PresentationPage';
import Themes from 'src/pages/Themes/Themes';
import pathToRegex from 'path-to-regexp';
import NewDashboard from 'src/dashboard/NewDashboard';
import AdminDashboard from 'src/pages/Admin/AdminDashboard';
import AdminBannerPage from 'src/pages/Admin/AdminBannerPage';

import CrowdsourceCreate from 'src/pages/Crowdsource/Create';

import ManageCollection from 'src/pages/Prioritize/Create/ManageCollection';
import ManageFactors from 'src/pages/Prioritize/Create/ManageFactors';
import PrioritizeParticipate from 'src/pages/Prioritize/Participate';
import PrioritizeResults from 'src/pages/Prioritize/Results';
import { withPayWall } from 'src/components/PayWall';

import SignUp from 'pages/SignUp/SignUp';

export const ROUTE_ERROR = 'error';
export const ROUTE_ORG_DASH_ANALYTICS = 'analytics';
export const ROUTE_ORG_DASH_SETTINGS = 'settings';
export const ROUTE_EVENT_DETAILS = 'q/:event/answers';
export const ROUTE_EVENT_PRESENT = 'q/:event/present';
export const ROUTE_NEW_DASHBOARD = 'dashboard';
export const ROUTE_BRANDING = 'branding';
export const ROUTE_CROWDSOURCE_CREATE = ':productType/create';
export const ROUTE_CROWDSOURCE_EDIT = ':productType/:slug/edit';
export const ROUTE_SURVEY_CREATE = ':productType/create';
export const ROUTE_SURVEY_EDIT = ':productType/:slug/edit';
export const ROUTE_PRIORITIZE_CREATE = 'p/create';
export const ROUTE_PRIORITIZE_EDIT = 'p/:collection/edit';
export const ROUTE_PRIORITIZE_EDIT_FACTORS = 'p/:collection/edit/factors';
export const ROUTE_PRIORITIZE_PARTICIPATE = 'p/:collection';
export const ROUTE_PRIORITIZE_RESULT = 'p/:collection/result';
export const ROUTE_PRIORITIZE_RESULT_DETAILS = 'p/:collection/result/:subCollection';
export const ROUTE_SIGNUP = 'signup';
export const ROUTE_ADMIN_AI_MONITORING = 'analytics/ai-monitoring';
export const ROUTE_ADMIN_BANNER = 'analytics/admin/banner';

const Path = (path, component, exact) => {
  return { path, component, exact };
};

export const ENTERPRISE_DASHBOARD_PATHS = [
  Path(ROUTE_ORG_DASH_ANALYTICS, Analytics, true),
  Path(ROUTE_ORG_DASH_SETTINGS, Settings, true),
  Path(ROUTE_ADMIN_AI_MONITORING, AdminDashboard, true),
  Path(ROUTE_ADMIN_BANNER, AdminBannerPage, true)
];

export const POPIN_PATHS = [
  Path(ROUTE_SIGNUP, SignUp, true),
  Path(ROUTE_BRANDING, Themes, false),
  Path(ROUTE_EVENT_DETAILS, CreatorReports, false),
  Path(ROUTE_EVENT_PRESENT, PresentationPage, false),
  // Prioritize
  Path(ROUTE_PRIORITIZE_CREATE, ManageCollection, true),
  Path(ROUTE_PRIORITIZE_EDIT, ManageCollection, true),
  Path(ROUTE_PRIORITIZE_EDIT_FACTORS, ManageFactors, false),
  Path(ROUTE_PRIORITIZE_RESULT, PrioritizeResults, false),
  Path(ROUTE_PRIORITIZE_RESULT_DETAILS, PrioritizeResults, false),
  Path(ROUTE_PRIORITIZE_PARTICIPATE, PrioritizeParticipate, false),
  // Crowdsource
  Path(ROUTE_CROWDSOURCE_CREATE, CrowdsourceCreate, true),
  Path(ROUTE_CROWDSOURCE_EDIT, CrowdsourceCreate, false),
  // Survey
  Path(ROUTE_SURVEY_CREATE, CrowdsourceCreate, true),
  Path(ROUTE_SURVEY_EDIT, CrowdsourceCreate, false),
  // Dashboard
  Path(ROUTE_NEW_DASHBOARD, NewDashboard, true)
];

const ALLOWED_PATHS = [
  Path(ROUTE_ERROR, ErrorPage, true)
];

const payWallPaths = (paths = []) => {
  // Prioritize
  const isPrioritizeRoute = (p) => p.path.match(/p\//);
  // Crowdsource + Survey
  const isCrowdsourceSurveyRoute = (p) => p.path.match(/:productType/);

  const isPayWalled = (p) =>
    isPrioritizeRoute(p) || isCrowdsourceSurveyRoute(p);

  const payWallOptions = { mode: 'fullComponent' };

  return paths.map((p) =>
    isPayWalled(p)
      ? { ...p, component: withPayWall(payWallOptions)(p.component) }
      : p
  );
};

const PAYWALLED_PATHS = payWallPaths(POPIN_PATHS);

for (let path of ENTERPRISE_DASHBOARD_PATHS) {
  ALLOWED_PATHS.push(path);
}

for (let path of PAYWALLED_PATHS) {
  ALLOWED_PATHS.push(path);
}

export const isEnterpriseUrl = (pathname) => {
  for (let pathObject of ENTERPRISE_DASHBOARD_PATHS) {
    const fullPath = `${GLOBAL_PATH_PREFIX}/${pathObject.path}`;
    if (fullPath === pathname) {
      return true;
    }
  }

  return false;
};

export const isNewDashboardUrl = (pathname) => {
  const fullPath = `${GLOBAL_PATH_PREFIX}/${ROUTE_NEW_DASHBOARD}`;
  return fullPath === pathname;
};

export const isPopinUrl = (pathname) => {
  // console.log('isPopinUrl', pathname);
  for (let pathObject of POPIN_PATHS) {
    const fullPath = `${GLOBAL_PATH_PREFIX}/${pathObject.path}`;
    const regex = pathToRegex(fullPath);
    // Returns undefined if it doesn't match
    if (regex.exec(pathname)) {
      return true;
    }
  }

  return false;
};

export const isPresentUrl = (pathname) => {
  const fullPath = `${GLOBAL_PATH_PREFIX}/${ROUTE_EVENT_PRESENT}`;
  const regex = pathToRegex(fullPath);

  // Returns undefined if it doesn't match
  return !!regex.exec(pathname);
};

class RedirectHome extends React.Component {

  isBadPath () {
    const { location } = this.props;
    const path = location.pathname;
    return ALLOWED_PATHS.filter(p => (path === `${GLOBAL_PATH_PREFIX}/${p.path}`));
  }

  render () {
    // if (this.isBadPath()) {
      return <Redirect to={ `${GLOBAL_PATH_PREFIX}/dashboard` } />;
    // } else {
      // return null;
    // }
  }
}

export default (
  <Switch>
    {
      ALLOWED_PATHS.map(
        p => {
          const fullPath = `${GLOBAL_PATH_PREFIX}/${p.path}`;
          return <Route
            exact={ p.exact }
            key={ fullPath }
            path={ fullPath }
            component={ p.component } />;
        }
      )
    }
    <Route component={ RedirectHome } />
  </Switch>
);
